import ReactDOM from 'react-dom';
import React, {Component} from 'react';
import {Category} from '../../base_components/rootComponents/Category';
import StreamlinedCategory from './rootComponents/StreamlinedCategory';

import { Item } from '../../base_components/rootComponents/Item';
import StreamlinedItem from './rootComponents/StreamlinedItem';

import {Welcome} from '../../base_components/rootComponents/Welcome';
import StreamlinedWelcome from './rootComponents/StreamlinedWelcome';

import { Specials } from '../../base_components/rootComponents/Specials';
import StreamlinedSpecials from './rootComponents/StreamlinedSpecials';

import { SpecialFlowPage } from '../../ui/specials';

import { Deals } from "./deals/deals";

import OrderTracker from './checkout/OrderTracker';


import ServiceTypeSelectorAnywhere from "./serviceTypes/ServiceTypeSelectorAnywhere";

import { UserAccountArea } from '../../ui/userAccountArea';

// add the bugsnag front end error reporting.
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

Bugsnag.start({
    apiKey: 'b55456eed60dc208d2dc95193a2a0be6',
    logger: null,
    appVersion: '2026.05',

    plugins: [new BugsnagPluginReact()],

    onError: function (event) {
        const error =
            event.errors &&
            event.errors[0];

        const message =
            (error && error.errorMessage) ||
            event.message ||
            '';

        const stacktrace =
            (error && error.stacktrace) ||
            [];

        const stackFiles = stacktrace
            .map(frame => frame.file || '')
            .join(' ');

        //Adding additional context to axios errors so it's actually useful.
        const axiosError =
            event.originalError ||
            event.error;

        if (axiosError && axiosError.config) {
            const method =
                axiosError.config.method || '';

            const url =
                axiosError.config.url || '';

            const baseURL =
                axiosError.config.baseURL || '';

            const status =
                axiosError.response &&
                axiosError.response.status;

            const isAxiosNetworkError =
                message === 'Network Error' &&
                !axiosError.response;

            if (isAxiosNetworkError) {
                return false;
            }

            // Add metadata to Bugsnag event
            event.addMetadata('axios', {
                method,
                url,
                baseURL,
                status,
                response:
                    axiosError.response &&
                    axiosError.response.data
            });

            // Make the event title/context useful
            event.context = [
                method.toUpperCase(),
                url,
                status && `(${status})`
            ]
                .filter(Boolean)
                .join(' ');

            // Improve the actual displayed error message
            if (error && url) {
                error.errorMessage =
                    `${method.toUpperCase()} ${url} failed` +
                    (status ? ` with ${status}` : '');
            }

            if (status === 419) {
                return false;
            }
        }

        //Google analytics noise.
        const isGoogleTagNoise =
            message.includes('ga is not defined') ||
            message.includes('gtag') ||
            message.includes('google-analytics') ||
            message.includes('GoogleAnalytics') ||
            message.includes('googletagmanager') ||
            stackFiles.includes('googletagmanager.com') ||
            stackFiles.includes('google-analytics.com') ||
            stackFiles.includes('analytics.js') ||
            stackFiles.includes('gtm.js');

        const isResizeObserverNoise =
            message === 'ResizeObserver loop completed with undelivered notifications.' ||
            message === 'ResizeObserver loop limit exceeded' ||
            message.includes('ResizeObserver loop');

        //Browser extension noise
        const isExtensionNoise =
            message.includes('runtime.sendMessage') ||
            message.includes('Tab not found') ||
            message.includes('Extension context invalidated') ||
            message.includes('The message port closed before a response was received') ||

            // Payment / checkout extension injection noise
            message.includes('remaining apms to detect') ||
            message.includes('DetectAlternatePaymentMethods') ||

            // Extension URLs
            stackFiles.includes('chrome-extension://') ||
            stackFiles.includes('moz-extension://') ||
            stackFiles.includes('safari-extension://') ||

            // Known injected script names
            stackFiles.includes('DetectAlternatePaymentMethods.js');

        // Ignore generic browser noise.
        const isGenericBrowserNoise =
            message === 'Script error.' ||
            message.includes('Non-Error promise rejection captured') ||
            message.includes('Network request failed');

        const isContactAutofillNoise =
            message.includes("Cannot read properties of undefined (reading 'value')") &&
            (
                stackFiles.includes('setContactAutofillValuesFromBridge') ||
                stackFiles.includes('/cart')
            );

        if (
            isGoogleTagNoise ||
            isResizeObserverNoise ||
            isExtensionNoise ||
            isGenericBrowserNoise ||
            isContactAutofillNoise
        ) {
            return false;
        }
    }
});

export const bugsnagClient = Bugsnag;
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
// end of fe reporting.
import { UserSignup } from "../../ui/userSignup";
import AppContent from "./AppContent";
import {VerticalCheckout} from "../../ui/verticalCheckout";
import { ResetPasswordForm } from "../../ui/resetPasswordForm";
/**
 * Mount the appropriate component on a per-page basis
 */

function addOuterContent(child) {
    return (
        <AppContent children={child} />
    );
}

export default function() {

    if (document.getElementById('categoryReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><Category content={<StreamlinedCategory />} /></ErrorBoundary>), document.getElementById('categoryReactContainer'));
    }

    if (document.getElementById('checkoutReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><VerticalCheckout /></ErrorBoundary>), document.getElementById('checkoutReactContainer'));
    }

    if (document.getElementById('menuReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><Welcome content={<StreamlinedWelcome />} /></ErrorBoundary>), document.getElementById('menuReactContainer'));
    }

    if (document.getElementById('itemReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><Item content={<StreamlinedItem />} /></ErrorBoundary>), document.getElementById('itemReactContainer'));
    }

    if (document.getElementById('userProfileReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><UserAccountArea /></ErrorBoundary>), document.getElementById('userProfileReactContainer'));
    }

    if (document.getElementById('welcomeReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><Welcome content={<StreamlinedWelcome />}/></ErrorBoundary>), document.getElementById('welcomeReactContainer'));
    }

    if (document.getElementById('orderTrackerReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><OrderTracker /></ErrorBoundary>), document.getElementById('orderTrackerReactContainer'));
    }

    if (document.getElementById('passwordResetReactContainer')) {
        ReactDOM.render(<ErrorBoundary><ResetPasswordForm /></ErrorBoundary>, document.getElementById('passwordResetReactContainer'));
    }

    if (document.getElementById('specialsReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><Specials content={<StreamlinedSpecials />}/></ErrorBoundary>), document.getElementById('specialsReactContainer'));
    }

    if (document.getElementById('specialReactContainer')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><SpecialFlowPage /></ErrorBoundary>), document.getElementById('specialReactContainer'));
    }

    if (document.getElementById('deals')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><Deals /></ErrorBoundary>), document.getElementById('deals'));
    }

    if (document.getElementById('ServiceTypeReactContainer')) {
        ReactDOM.render(<ErrorBoundary><ServiceTypeSelectorAnywhere /></ErrorBoundary>, document.getElementById('ServiceTypeReactContainer'));
    }

    if (document.getElementById('user_sign_up')) {
        ReactDOM.render(addOuterContent(<ErrorBoundary><UserSignup /></ErrorBoundary>), document.getElementById('user_sign_up'));
    }
}
